import React from "react";
import { useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import CreateNewProjectPaneView from "./CreateNewProjectPaneView";
import {
  closeCreateNewProjectPane,
  createNewProjectActionValue,
} from "./utils";
import generateUuid from "src/app/libs/generateUuid";
import { setOpenAddBriefPaneForNewProject } from "src/redux/main/mainActions";
import { RootState } from "src/redux/reducers";
import AddAIBriefPaneNewProject from "./AddAIBriefPaneNewProject";
import FilePreviewDisplay from "src/app/components/FilePreviewDisplay/FilePreviewDisplay";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

function NewProjectBriefPreview() {
  const { isNewProjectBriefLoading, newProjectBriefData } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const dispatch = useDispatch();

  const handleOpenAddBriefPane = () => {
    dispatch(setOpenAddBriefPaneForNewProject(true));
  };

  const shouldDisplayPreview =
    Boolean(newProjectBriefData?.name) || Boolean(newProjectBriefData?.result);

  return (
    <FilePreviewDisplay
      onOpenPreview={handleOpenAddBriefPane}
      isLoading={isNewProjectBriefLoading}
      fileName={newProjectBriefData?.name ?? ""}
      shouldDisplayPreview={shouldDisplayPreview}
      label={
        <IDHFormattedMessage
          id="ws_campaign_brief"
          defaultMessage="Campaign brief"
        />
      }
    />
  );
}

export default function CreateNewProjectPane() {
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const isActive = params.get("action") === createNewProjectActionValue;

  const projectId = isActive ? generateUuid() : "";

  if (!isActive) return null;

  return (
    <>
      <CreateNewProjectPaneView
        onClose={() => closeCreateNewProjectPane(history)}
        action="create"
        projectId={projectId}
        briefPreview={<NewProjectBriefPreview />}
      />
      <AddAIBriefPaneNewProject />
    </>
  );
}
